<template>
  <div class="con">
    <h1 class="title">CFWA</h1>
    <p class="p-title">Certified Family Wealth Adviso</p>
    <!--详情-->
    <div class="cfwa-txt">
      <p>
        CFWA 家族首席财富顾问研修班(晓恒博士弟子班），致力
        于培养服务于高净值客户的家族财富顾问，助您打造高端品
        牌，开拓高端市场，提供高端服务，促进大额保单。
      </p>
      <img src="/static/images/img1.png" alt="">
      <p>
        CFWA 家族首席财富顾问研修班(晓恒博士弟子班），致力
        于培养服务于高净值客户的家族财富顾问，助您打造高端品
        牌，开拓高端市场，提供高端服务，促进大额保单。
      </p>
    </div>
    <!--愿景使命-->
    <div class="yuan-title">
      <img src="/static/images/img2.png" alt="">
    </div>
    <div class="yuan-txt">
      <p>
        以保护、传承家族财富使命，以复兴、繁荣家族精神为价值，
        尽心服务中国企业家,守富传富、由富及富，实现家族正真意
        义上的“恒永远，通天下”。
      </p>
      <img src="/static/images/img3.png" alt="">
    </div>
    <!--往期精彩回顾-->
    <div class="hui-title">
      <img src="/static/images/img4.png" alt="">
    </div>
    <div class="hui-txt">
      <p>
        以保护、传承家族财富使命，以复兴、繁荣家族精神为价值，
        尽心服务中国企业家,守富传富、由富及富，实现家族正真意
        义上的“恒永远，通天下”。
      </p>
      <img src="/static/images/img6.png" alt="">
      <img src="/static/images/img7.png" alt="">
    </div>
    <!--学员反馈-->
    <div class="fan-title">
      <img src="/static/images/img5.png" alt="">
    </div>
    <div class="fan-txt">
      <p>
        以保护、传承家族财富使命，以复兴、繁荣家族精神为价值，
        尽心服务中国企业家,守富传富、由富及富，实现家族正真意
        义上的“恒永远，通天下”。
      </p>
      <img src="/static/images/img8.png" alt="">
    </div>
    <div class="line"></div>
    <div class="reply">
      课程报名
    </div>
  </div>

</template>

<script>
export default {
  name: 'cfwa',
  data () {
    return {

    }
  },
  mounted(){

  },
  methods:{}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con{
    padding: 0.3rem;
  }
  .con h1.title{
    color: #333;
    font-size: 0.36rem;
    text-align: center;
  }
  .con p.p-title{
    font-size: 0.22rem;
    color: #333;
    text-align: center;
    margin-top: 0.1rem;
  }
  .cfwa-txt{
    margin-top: 0.3rem;
  }
  .cfwa-txt p,.yuan-txt p,.hui-txt p,.fan-txt p{
    font-size: 0.24rem;
    color: #333;
    line-height: 0.48rem;
  }
  .cfwa-txt img,.yuan-txt img,.hui-txt img,.fan-txt img{
    display: block;
    width: 100% !important;
    height: auto !important;
    margin: 0.4rem 0;
  }
  .yuan-title,.hui-title,.fan-title{
    margin-top: 0.86rem;
    margin-bottom: 0.5rem;
  }
  .yuan-title img,.hui-title img,.fan-title img{
    display: block;
    width: 100%;
    height: auto;
  }
  .reply{
    position: fixed;
    width: 100%;
    height: 0.97rem;
    line-height: 0.97rem;
    text-align: center;
    background-color: #d7b177;
    bottom: 0;
    left: 0;
    font-size: 0.32rem;
    color: #fff;
  }
  .line{
    height: 0.97rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/cfwa.vue